var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { Typography, Card, CardBody, Alert, } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ERR_SAVE, USER_RESEND_INVITE_ERROR_MESSAGE, } from '../../constants/response-error-messages';
import { useAddManageUsers } from '../../hooks/use-add-manage-users';
import { addManageUsersApi } from '../../api/b2b/add-manage-user';
import { useModal } from '../../hooks/use-modal';
import { DeleteUserModal, } from '../modal/delete-user-modal/delete-user-modal';
import { convertToMDYYYY, getHost, getHyphenatedPhoneNumber, checkIsInviteExpirationEnabled, scrollToTop, } from '../../utils/general';
import { TAlertStatus, TAlertType } from '../../models/common/alert-messages';
import { USER_FORM_MODE, } from '../../models/b2b/add-manage-users';
import { MeatballsMenu } from '../meatball-menu/meatball-menu';
import { USER_REMOVED_SUCCESS_MSG, USER_RESEND_INVITE_SUCCESS_MSG, } from '../../constants/response-success-messages';
import { setCardLinkAnalytics, setMeatBallsAnalytics, setRemoveUserSuccessAnalytics, } from '../../utils/add-manage-user-analytics';
import { PRO_ALLOWANCE_PATH } from '../../constants/links';
import { UserInviteAlert } from './user-invite-alert';
import { addUserValidationSchema } from '../user-form/validation';
import { RESEND_INVITE_USER_INVALID } from '../../constants/field-error-messages';
var MeatballMenuValues = {
    EDIT: 'Edit',
    REMOVE: 'Remove',
    ASSIGN_PRO_ALLOWANCE: 'Assign Pro Allowance',
    RESEND_INVITE: 'Resend Invite',
};
export var UserCard = function (_a) {
    var index = _a.index, user = _a.user, _b = _a.showMeatballsMenu, showMeatballsMenu = _b === void 0 ? true : _b, onActionSuccess = _a.onActionSuccess, onActionFailure = _a.onActionFailure;
    var firstName = user.firstName, lastName = user.lastName, role = user.role, status = user.status, phone = user.phone, email = user.email, addedDate = user.addedDate, userId = user.userId, accountOwner = user.accountOwner, isInviteExpired = user.isInviteExpired, activatedDate = user.activatedDate;
    var _c = useModal(), openModal = _c.openModal, hideModal = _c.hideModal, setComponentProps = _c.setComponentProps;
    var _d = useAddManageUsers(), alertMessage = _d.alertMessage, setAlertMessage = _d.setAlertMessage, setFormMode = _d.setFormMode, setEditableUser = _d.setEditableUser, isPartOfRunnerAllowance = _d.isPartOfRunnerAllowance;
    var channel = useContext(ExperienceContext).channel;
    var isMobile = channel === 'mobile';
    var isDesktop = channel === 'desktop';
    var isAdmin = role === 'Admin';
    var isPending = status === 'Pending';
    var isAccountOwner = accountOwner === 'Y';
    var isDeleteMsg = (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.text) === USER_REMOVED_SUCCESS_MSG.message;
    var isActivated = activatedDate && status === 'Active';
    var mobileCardAlertMsg = isMobile &&
        alertMessage &&
        !!alertMessage.cardIndex &&
        alertMessage.id === userId &&
        !isDeleteMsg && (React.createElement("div", { className: "sui-my-4" },
        React.createElement(Alert, { "data-testid": "mobileCardAlertMsg", status: alertMessage.alertStatus, onClose: function () { return setAlertMessage(null); } }, alertMessage.text)));
    var inviteStatus = null;
    var alertStatus = null;
    if ((!isActivated && checkIsInviteExpirationEnabled() && isInviteExpired) ||
        (isInviteExpired === undefined && status === 'Pending')) {
        alertStatus = 'warning';
        inviteStatus = 'expired';
    }
    else if (isPending) {
        alertStatus = 'info';
        inviteStatus = 'pending';
    }
    var deleteUser = function () {
        setComponentProps({ isLoading: true });
        addManageUsersApi
            .deleteUser(userId)
            .then(function () {
            setRemoveUserSuccessAnalytics();
            if (onActionSuccess) {
                onActionSuccess(index, userId, USER_REMOVED_SUCCESS_MSG.message);
            }
        })
            .catch(function () {
            if (onActionFailure) {
                onActionFailure(index, userId, ERR_SAVE.message);
            }
        })
            .finally(function () {
            setComponentProps({ isLoading: false });
            hideModal();
            if (isDesktop) {
                scrollToTop();
            }
        });
    };
    var menuItems = [
        {
            value: MeatballMenuValues.EDIT,
            action: function () {
                setMeatBallsAnalytics('edit');
                setAlertMessage(null);
                setEditableUser(user);
                setFormMode(USER_FORM_MODE.EDIT_USER);
            },
            isDisabled: isPending,
        },
        {
            value: MeatballMenuValues.REMOVE,
            action: function () {
                setMeatBallsAnalytics('remove');
                openModal(DeleteUserModal, {
                    user: user,
                    isLoading: false,
                    onConfirmDelete: deleteUser,
                    hideModal: hideModal,
                });
            },
        },
        {
            value: MeatballMenuValues.ASSIGN_PRO_ALLOWANCE,
            action: function () {
                setMeatBallsAnalytics('assign pro allowance');
                window.location.assign("".concat(getHost()).concat(PRO_ALLOWANCE_PATH));
            },
            isHidden: isAdmin || !isPartOfRunnerAllowance,
            isDisabled: isPending,
        },
        {
            value: MeatballMenuValues.RESEND_INVITE,
            action: function () {
                setMeatBallsAnalytics('resend invite');
                handleResendInviteLink();
            },
            isHidden: !isPending,
        },
    ];
    var handleResendInviteLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCardLinkAnalytics('resend invite');
                    return [4 /*yield*/, addUserValidationSchema.isValid(user)];
                case 1:
                    isValid = _a.sent();
                    if (!isValid) {
                        setAlertMessage({
                            text: RESEND_INVITE_USER_INVALID.message,
                            alertStatus: TAlertStatus.ERROR,
                            id: 'user.userId',
                            cardIndex: index,
                            type: TAlertType.GENERAL,
                        });
                        return [2 /*return*/];
                    }
                    addManageUsersApi
                        .resendInvite(user)
                        .then(function (_a) {
                        var userInviteExpirationDate = _a.data.userInviteExpirationDate;
                        setCardLinkAnalytics('resend invite success');
                        if (onActionSuccess) {
                            onActionSuccess(index, userId, checkIsInviteExpirationEnabled() && userInviteExpirationDate
                                ? USER_RESEND_INVITE_SUCCESS_MSG.message(userInviteExpirationDate)
                                : 'Invite Resent');
                        }
                    })
                        .catch(function () {
                        setAlertMessage({
                            text: USER_RESEND_INVITE_ERROR_MESSAGE.message,
                            alertStatus: TAlertStatus.ERROR,
                            id: 'user.userId',
                            cardIndex: index,
                            type: TAlertType.GENERAL,
                        });
                    })
                        .finally(function () {
                        if (isDesktop) {
                            scrollToTop();
                        }
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "sui-flex sui-flex-col-reverse sui-h-full sui-w-full sui-overflow-hidden" },
        mobileCardAlertMsg,
        React.createElement(Card, { "data-testid": "userDataContainer", PaperProps: { className: 'sui-w-full sui-h-full ' } },
            React.createElement("div", null,
                React.createElement(Typography, { weight: "bold", color: "subtle", "data-testid": "userRoleContainer_".concat(index) }, role),
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { truncate: true, variant: "h3", "data-testid": "userFnameLnameContainer_".concat(index), "data-qm-mask": "" },
                        firstName,
                        " ",
                        lastName),
                    React.createElement("div", null, !isAccountOwner && showMeatballsMenu && (React.createElement(MeatballsMenu, { label: "User", items: menuItems }))))),
            React.createElement(CardBody, null,
                React.createElement("div", { className: "sui-grid sui-gap-y-3 sui-overflow-hidden" },
                    React.createElement(Typography, { truncate: true, variant: "body-base", height: "tight", "data-testid": "userEmailContainer_".concat(index), "data-qm-mask": "" }, email),
                    React.createElement(Typography, { variant: "body-base", height: "tight", "data-testid": "userPhContainer_".concat(index), "data-qm-mask": "" }, phone ? getHyphenatedPhoneNumber(phone) : React.createElement(React.Fragment, null, "\u00A0")),
                    React.createElement(Typography, { variant: "body-base", height: "tight", color: "subtle", "data-testid": "userAddedDateContainer_".concat(index) },
                        "Added ",
                        convertToMDYYYY(addedDate)))),
            inviteStatus && alertStatus && (React.createElement(UserInviteAlert, { handleResendInviteLink: handleResendInviteLink, inviteStatus: inviteStatus, alertStatus: alertStatus })))));
};
